export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR";

export const SET_NOTIFICATIONS_FILTERS = "SET_NOTIFICATIONS_FILTERS";

export const PUT_NOTIFICATIONS = "PUT_NOTIFICATIONS";
export const PUT_NOTIFICATIONS_SUCCESS = "PUT_NOTIFICATIONS_SUCCESS";
export const PUT_NOTIFICATIONS_ERROR = "PUT_NOTIFICATIONS_ERROR";
